import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

/**
 * Usage:
 * <ProtectedRoute allowedRoles={["doctor", "admin"]}>
 *   <Route ... />
 * </ProtectedRoute>
 */
export default function ProtectedRoute({ allowedRoles, children }) {
  const { user } = useContext(AuthContext);
  if (!user) {
    // Not logged in, redirect to login
    return <Navigate to="/login" replace />;
  }
  if (!allowedRoles.includes(user.role)) {
    // Logged in but not allowed, redirect to home
    return <Navigate to="/" replace />;
  }
  return children;
}
